module.exports = __webpack_public_path__ + "img/start-mini-4.8b19c236.jpg";